import React from 'react';
import classnames from 'classnames/bind';
import { TuuiTheme } from 'tuui';
import { chatAgentTheme } from './tuuiChatAgentTheme';
import styles from './taboola-ultimate-ui.chat-agent.theme.module.scss';

const classNameBuilder = classnames.bind(styles);

export const ChatAgentThemeWrapper = ({ children, disabled, className }) => {
    const theme = disabled ? undefined : chatAgentTheme;

    return (
        <TuuiTheme theme={theme}>
            <div className={classNameBuilder({ chatAgent: !disabled }, className)}>{children}</div>
        </TuuiTheme>
    );
};
